var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindGusts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "2 16.5 122 96",
    width: 122,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#eb5428af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "15%",
    stopColor: "#eb54286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#eb542800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eb5428ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1",
    strokeOpacity: 1,
    strokeDasharray: "none",
    stroke: "none",
    fillOpacity: 1,
    fill: "url(#linear)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphic_16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 100 63.3 L 21.1 63.3 C 18.4 63.3 16.2 65.5 16.2 68.2 C 16.2 70.9 18.4 73.1 21.1 73.1 L 100 73.1 C 108.1 73.1 114.6 79.8 114.6 87.9 C 114.6 96 108.1 102.6 100 102.6 C 91.9 102.6 85.4 96 85.4 87.9 C 85.4 86.6 85.5 85.2 85.8 83.9 C 86.1 82.6 85.9 81.3 85.2 80.2 C 84.5 79.1 83.4 78.3 82.1 78 C 79.4 77.4 76.8 79.1 76.2 81.8 C 75.8 83.7 75.6 85.7 75.6 87.7 C 75.5 97.7 81.4 106.7 90.5 110.6 C 99.6 114.4 110.1 112.4 117.1 105.4 C 124.1 98.4 126.3 87.8 122.5 78.5 C 118.8 69.3 109.9 63.3 100 63.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.9 78.6 L 7.2 78.6 C 4.5 78.6 2.3 80.8 2.3 83.5 C 2.3 86.2 4.5 88.5 7.2 88.5 L 52.9 88.5 C 55 88.4 56.9 90 57.2 92.2 C 57.4 94.4 56.1 96.4 53.9 96.9 C 51.8 97.4 49.7 96.2 49 94.2 C 48.3 92.3 46.6 91 44.6 90.9 C 42.7 90.8 40.8 91.9 40 93.7 C 39.4 94.9 39.3 96.2 39.8 97.5 C 42.2 104.2 49.2 108.1 56.1 106.5 C 63.1 104.9 67.7 98.3 66.9 91.1 C 66.1 84 60.1 78.6 53 78.6 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36.7 57.2 L 90.4 57.2 C 101.5 57.2 110.6 48.1 110.6 36.9 C 110.6 25.6 101.5 16.5 90.4 16.5 C 79.3 16.5 70.2 25.6 70.2 36.9 C 70.2 39.6 72.4 41.8 75.1 41.8 C 77.8 41.8 80 39.6 80 36.9 C 80 32.6 82.5 28.8 86.4 27.2 C 90.3 25.5 94.8 26.4 97.8 29.4 C 100.8 32.4 101.7 37 100 40.9 C 98.4 44.8 94.6 47.4 90.4 47.4 L 36.7 47.4 C 34 47.4 31.8 49.6 31.8 52.3 C 31.8 55.1 34 57.3 36.7 57.3 Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindGusts);
export default __webpack_public_path__ + "static/media/windGusts.526bad72.svg";
export { ForwardRef as ReactComponent };